import {apiAddPaymentMethodToken, PaymentMethod} from "../../../../client/state/PaymentMethodStore.js";
import {Messages} from "../../../Messages.js";
import {iFrameUserDataService} from "../../../services/IFrameUserDataService.js";
import {Router} from "../../../../stem-core/ui/Router.jsx";
import {PAYMENT_DETAILS_PANEL_URL} from "../../PanelConstants.js";
import {BaseFlowStep} from "./BaseFlowStep.jsx";


export class PaymentMethodFlowStep extends BaseFlowStep {
    continueLabel = Messages.finalizePayment;
    scope = PaymentMethod.Scope.PUBLIC;
    cardHolderName = ""; // The IDE seems to fail to interpret this as being used, but it actually is.
    showSaveCardCheckbox = true; // If you want to allow an iframe option to override this, track where this variable is used
    entry = null;
    savePaymentMethod = true;
    retryPayment = null;
    paymentError = null;
    altPayData = null; // AmazonPay or PayPal
    unprocessedNewToken = null; // If there's a token that needs to be added, should a pair {token, scope, paymentProcessor}

    haveOptionsAvailable() {
        return this.selectedValue || iFrameUserDataService.getExtraPaymentMethodCount();
    }

    getDefaultFields() {
        this.selectedValue = PaymentMethod.getDefault();
    }

    getFieldsToReset() {
        const obj = super.getFieldsToReset();
        if (this.selectedValue) {
            delete obj.cardHolderName;
        }
        delete obj.unprocessedNewToken;
        return obj;
    }

    showPanel() {
        Router.changeURL(PAYMENT_DETAILS_PANEL_URL);
    }

    async getPayload() {
        return {
            preferredPaymentMethodId: this.selectedValue?.id, // TODO @cleanup rename to paymentMethodId
        }
    }

    async sendUnprocessedNewToken() {
        const request = this.unprocessedNewToken;
        if (request == null) {
            throw Error("No existing token to send");
        }
        this.unprocessedNewToken = null;
        const {token, scope, paymentProcessor} = request;
        this.selectedValue = await apiAddPaymentMethodToken(token, scope, paymentProcessor);
        return this.selectedValue;
    }

    maskPayload(payload) {
        return {...payload};
    }

    getPaymentErrorMessage() {
        return this.paymentError?.message || "";
    }

    setAltPayOrderId(provider, orderId) {
        // If provider is null, clear the field
        const altPayData = provider && {
            provider,
            orderId,
        }
        this.update({altPayData});
    }
}
